import {useEffect, useState} from "react"

export const useTableConfig = ({rowsData, unmutableRows, columns}) => {

    const [rows, setRows] = useState(rowsData)
    const unmuRows = unmutableRows
    const [isEditing, setIsEditing] = useState(false)
    const [showEditingPopup, setShowEditingPopup] = useState(false)
    const [editingRows, setEditingRows] = useState()
    const [editingColumns, setEditColumns] = useState([])
    const [editedRows, setEditedRows] = useState()
    const [leftColumns, setLeftColumns] = useState([]);
    const [currentColumnEdition, setCurrentColumnEdition] = useState({})
    const [inputEditings, setInputEditings] = useState([])

    useEffect(() => {
        setEditingRows(rows.filter(e => e.type !== 'step').map(e => e.id))
        setEditColumns(columns.map(c => {
            return {columnName: c.name, editingEnabled: c.editable}
        }))
    }, [columns, rows])

    const changeColumns = (columnName) => {
        if (leftColumns.includes(columnName)) {
            setLeftColumns(leftColumns.filter(x => x !== columnName))
        } else {
            setLeftColumns([...leftColumns, columnName])
        }
    }

    const setValues = (value, type) => {
        const valueInPercents = parseFloat(value) / 100
        rows.forEach(row => {
            if (row[currentColumnEdition.name] && row.type == "row") {
                const convertedValue = parseFloat(row[currentColumnEdition.name])
                if (type === 'increase') {
                    row[currentColumnEdition.name] = (convertedValue + (convertedValue * valueInPercents)).toFixed(2)
                    row['editado'] = true
                } else {
                    row[currentColumnEdition.name] = (convertedValue - (convertedValue * valueInPercents)).toFixed(2)
                    row['editado'] = true
                }
            }
        })
    }

    const [tableColumnExtensions] = useState(columns.map(c => {
        return {columnName: c.name, width: c.width}
    }));

    const getChildRows = (row, rootRows) => {
        const childRows = rootRows.filter(r => r.parentId === (row ? row.id : null));
        return childRows.length ? childRows : null;
    };

    const getRowId = row => row.id;

    const commitChanges = ({changed}) => {
        let changedRows;

        if (changed) {
            changedRows = rows.map(row => (changed[row.id] ? {...row, ...changed[row.id]} : row));
        }
        setRows(changedRows);
    };

    const undoChanges = () => setRows(unmutableRows)

    return {
        setIsEditing,
        isEditing,
        tableColumnExtensions,
        getChildRows,
        rows,
        unmuRows,
        commitChanges,
        getRowId,
        leftColumns,
        changeColumns,
        editedRows,
        setEditedRows,
        editingRows,
        editingColumns,
        setEditingRows,
        undoChanges,
        showEditingPopup,
        setShowEditingPopup,
        currentColumnEdition,
        setCurrentColumnEdition,
        setValues,
        inputEditings,
        setInputEditings
    }
}
